import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type {
	PensionCreateFormInput,
	PensionEditFormInput,
} from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";

const PENSION_FORM_BASE_DEFAULT_VALUES: PensionEditFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
	payment: null,
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
	employerContribution: null,
	ageLimit: null,
	appreciation: null,
};

export const PENSION_EDIT_FORM_DEFAULT_VALUES: PensionEditFormInput =
	PENSION_FORM_BASE_DEFAULT_VALUES;

export const getPensionCreateFormDefaultValues =
	(): PensionCreateFormInput => ({
		...PENSION_FORM_BASE_DEFAULT_VALUES,
		value: null,
		invested: null,
		valueDate: new Date(),
	});
